export enum WebsiteComponentEnum {
  Calculator = 'calculator',
  Management = 'management',
  Setup = 'setup',
  Website = 'website',
  ExternalAddressing = 'externalAddressing',
}
